import './index.css';
import {RouteObject} from "react-router-dom"
import {Error404Page, RouterErrorPage} from "@/components/Errors.tsx";
import Redirector from "@/components/Redirector.tsx";
import {App} from "@/App.tsx";

export const routes: RouteObject[] = [
    {
        path: "/",
        element: <App/>,
        errorElement: <RouterErrorPage/>,
        children: [
            {path: "*", element: <Error404Page/>},
            {path: "/", lazy: () => import("@/pages/page.tsx")},
            {path: "/users", lazy: () => import("@/pages/users/page.tsx")},
            {path: "/users/:id", lazy: () => import("@/pages/users/{id}/page.tsx")},
            {path: "/calendar", lazy: () => import("@/pages/calendar/page.tsx")},
            {path: "/calendar/categories", lazy: () => import("@/pages/calendar/categories/page.tsx")},
            {path: "/config", lazy: () => import("@/pages/config/page.tsx")},
            {path: "/cpm_order_tracking", element: <Redirector to={"/cpm/order_tracking"}/>},
            {path: "/cpm/order_tracking", lazy: () => import("@/pages/cpm/order_tracking/page.tsx")},
            {path: "/scorecard", element: <Redirector to={"/teams"}/>},
            {path: "/teams", lazy: () => import("@/pages/teams/page.tsx")},
            {path: "/teams/admin", lazy: () => import("@/pages/teams/admin/page.tsx")},
            {path: "/teams/admin/:id", lazy: () => import("@/pages/teams/admin/{id}/page.tsx")},
            {path: "/scorecard/measurables", lazy: () => import("@/pages/scorecard/measurables/page.tsx")},
            {path: "/scorecard/teams/:id", lazy: () => import("@/pages/scorecard/teams/{id}/page.tsx")},
            {path: "/api_key", lazy: () => import("@/pages/api_key/page.tsx")},
            {path: "/flexlm", lazy: () => import("@/pages/flexlm/page.tsx")},
            {path: "/dyn_dns", lazy: () => import("@/pages/dyn_dns/page.tsx")},
            {path: "/doors", lazy: () => import("@/pages/doors/page.tsx")},
            {path: "/about", lazy: () => import("@/pages/about/page.tsx")},
            {path: "/accountability_chart/*", lazy: () => import("@/pages/accountability_chart/page.tsx")},
            {path: "/api_docs", lazy: () => import("@/pages/api_docs/page")},
            {path: "/audit", lazy: () => import("@/pages/audit/page.tsx")},
            {path: "/vto", lazy: () => import("@/pages/vto/page")},
            {path: "/vto/:teamId", lazy: () => import("@/pages/vto/page")},
            {path: "/vto/:teamId/:tab", lazy: () => import("@/pages/vto/page")},
            {path: "/permission_audit", lazy: () => import("@/pages/permission_audit/page.tsx")},
            {path: "/job_log", lazy: () => import("@/pages/job_log/page.tsx")},
            {path: "/job_log/:id", lazy: () => import("@/pages/job_log/{id}/page.tsx")},
            {path: "/customers", lazy: () => import("@/pages/customers/page.tsx")},
            {path: "/customers/id/:customerId", lazy: () => import("@/pages/customers/{customerNumber}/page.tsx")},
            {path: "/customers/:customerNumber", lazy: () => import("@/pages/customers/{customerNumber}/page.tsx")},
            {path: "/projects", lazy: () => import("@/pages/projects/page.tsx")},
            {path: "/projects/:id", lazy: () => import("@/pages/projects/{id}/page.tsx")},
            {path: "/projects/:id/:tab", lazy: () => import("@/pages/projects/{id}/page.tsx")},
            {path: "/misys_stock", element: <Redirector to={"/cpm/stock"}/>},
            {path: "/cpm/stock", lazy: () => import("@/pages/cpm/stock/page.tsx")},
            {path: "/bravobits", lazy: () => import("@/pages/bravobits/page.tsx")},
            {path: "/bravobits/:tab", lazy: () => import("@/pages/bravobits/page.tsx")},
            {path: "/shipping_request", lazy: () => import("@/pages/shipping_request/page.tsx")},
            {path: "/shipping_request/submit", lazy: () => import("@/pages/shipping_request/submit/page.tsx")},
            {path: "/timecards/manage", lazy: () => import("@/pages/timecards/manage/page.tsx")},
            {path: "/timecards/admin", lazy: () => import("@/pages/timecards/manage/page.tsx")},
            {path: "/timecards/me", lazy: () => import("@/pages/timecards/me/page.tsx")},
            {path: "/timecards/me/:tab", lazy: () => import("@/pages/timecards/me/page.tsx")},
            {path: "/timecards/reports", lazy: () => import("@/pages/timecards/reports/page.tsx")},
            {path: "/timecards/reports/task_class_hours", lazy: () => import("@/pages/timecards/reports/task_class_hours/page.tsx")},
            {path: "/timecards/reports/zbill_internal_audit", lazy: () => import("@/pages/timecards/reports/zbill_internal_audit/page.tsx")},
            {path: "/document_numbers", lazy: () => import("@/pages/document_number/page.tsx")},
            {path: "/document_numbers/:docType", lazy: () => import("@/pages/document_number/page.tsx")},
            {path: "/op_workflows", lazy: () => import("@/pages/op_workflows/page.tsx")},
            {path: "/op_workflows/:id", lazy: () => import("@/pages/op_workflows/{id}/page.tsx")},
            {path: "/haproxy", lazy: () => import("@/pages/haproxy/page.tsx")},
        ]
    },
    {
        path: "/timeclock",
        lazy: () => import("@/pages/timeclock/page.tsx")
    }
]